/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-pdf-configuration',
  templateUrl: './pdf-configuration.page.html',
  styleUrls: ['./pdf-configuration.page.scss'],
})
export class PdfConfigurationPage implements OnInit {
  // Example properties
  paperSizes = ['A4', 'A3', 'LETTER', 'LEGAL']; 
  selectedPaperSize = 'A4'; // Default selection
  pageOrientations = ['portrait', 'landscape']; 
  selectedPageOrientation = 'landscape'; // Default selection
  numOfRefColumns = 1; // Default value
  maxColumnContentLength = 150; //default value

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    // Initialization logic if needed
  }

  // Method to handle changes in paper size selection
  onPaperSizeChange(selectedSize: string) {
    this.selectedPaperSize = selectedSize;
  }

  // Method to handle changes in page orientation selection
  onPageOrientationChange(selectedOrientation: string) {
    this.selectedPageOrientation = selectedOrientation;
  }


  // Method to initiate PDF export with selected options
  exportPdf() {
    this.modalController.dismiss({
      selectedPaperSize: this.selectedPaperSize,
      numFrozenColumns: this.numOfRefColumns,
      selectedPageOrientation: this.selectedPageOrientation,
      userDefinedMaxLength: this.maxColumnContentLength
    });
  }

  
  
}
